import { ConsultaSeguimentoArrowDown } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoArrowDown'
import { ConsultaSeguimentoIndicatorResultado } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorResultado'
import { ConsultaSeguimentoIndicatorStart } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoIndicatorStart'
import { ConsultaSeguimentoPerguntaHeader } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeader'
import { ConsultaSeguimentoPerguntaHeaderTitle } from '@mchat-rf/consulta-seguimento/components/ConsultaSeguimentoPerguntaHeaderTitle'
import { PerguntaSimNaoRadioGroupBoxField } from '@mchat-rf/consulta-seguimento/components/PerguntaSimNaoRadioGroupBoxField'
import { isPerguntaStatusRespondendo } from '@mchat-rf/consulta-seguimento/consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { useConsultaSeguimentoAutoScroll } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { useConsultaSeguimentoSetResultado } from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoSetResultado'
import { Flow, Text, VFlow } from 'bold-ui'
import { resolveName, SimNaoEnum } from 'components/form'
import { SimNaoSwitchButtonField } from 'components/form/field/SimNaoSwitchButtonField'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { RefObject } from 'react'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoPergunta19Model } from './model-consultaSeguimentoPergunta19'
import { PERGUNTA_19_SCROLL_CONFIG } from './scrollConfig-consultaSeguimentoPergunta19'
import { calculateResultadoPergunta19, conditionToCalculatePergunta19 } from './utils-consultaSeguimentoPergunta19'

interface ConsultaSeguimentoPergunta19FieldProps {
  name: MetaPath<ConsultaSeguimentoPergunta19Model>
  containerRef: RefObject<HTMLDivElement>
  goNextButtonRef: RefObject<HTMLButtonElement>
}

export function ConsultaSeguimentoPergunta19Field(props: Readonly<ConsultaSeguimentoPergunta19FieldProps>) {
  const { name, containerRef, goNextButtonRef } = props

  const {
    input: { value },
  } = useField<ConsultaSeguimentoPergunta19Model>(resolveName(name), {
    subscription: { value: true },
  })

  useConsultaSeguimentoSetResultado<ConsultaSeguimentoPergunta19Model>({
    name,
    conditionToCalculate: conditionToCalculatePergunta19,
    calculateResultado: calculateResultadoPergunta19,
  })

  const { getId, triggerScrollFor } = useConsultaSeguimentoAutoScroll<ConsultaSeguimentoPergunta19Model>({
    name,
    containerRef,
    goNextButtonRef,
    scrollConfig: PERGUNTA_19_SCROLL_CONFIG,
  })

  return (
    <VFlow vSpacing={0}>
      <VFlow>
        {isPerguntaStatusRespondendo(value.status) && (
          <ConsultaSeguimentoPerguntaHeader
            pergunta={MChatPerguntaEnum.PERGUNTA_19}
            title={
              <ConsultaSeguimentoPerguntaHeaderTitle
                prefix='Se acontecer alguma coisa nova,'
                sufix=' olha para o seu rosto para ver como você se sente sobre isso?'
              />
            }
            status={value.status}
            field={
              <SimNaoSwitchButtonField
                name={name.PERGUNTA_19_HEADER}
                onChange={() => triggerScrollFor('PERGUNTA_19_HEADER')}
              />
            }
          />
        )}
        {value.PERGUNTA_19_HEADER === SimNaoEnum.NAO && (
          <VFlow vSpacing={0} id={getId('PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO')}>
            <ConsultaSeguimentoIndicatorStart />
            <PerguntaSimNaoRadioGroupBoxField
              name={name.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO}
              label={
                <Text color='inherit'>
                  Se o seu filho ouve um barulho estranho ou assustador, ele olha para você, <u>antes</u> de responder?
                </Text>
              }
              required
              onChange={() => triggerScrollFor('PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO')}
            />
            {value.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.NAO && (
              <Flow direction='vertical' gap={0} id={getId('PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA')}>
                <ConsultaSeguimentoArrowDown />
                <PerguntaSimNaoRadioGroupBoxField
                  name={name.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA}
                  label={
                    <Text color='inherit'>
                      O seu filho <u>olha para você</u> quando uma pessoa estranha se aproxima?
                    </Text>
                  }
                  required
                  onChange={() => triggerScrollFor('PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA')}
                />
                {value.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.NAO && (
                  <Flow direction='vertical' gap={0} id={getId('PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO')}>
                    <ConsultaSeguimentoArrowDown />
                    <PerguntaSimNaoRadioGroupBoxField
                      name={name.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO}
                      label={
                        <Text color='inherit'>
                          Seu filho <u>olha para você</u> quando ele vê algo não familiar ou que dá um pouco de medo?
                        </Text>
                      }
                      required
                      onChange={() => triggerScrollFor('PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO')}
                    />
                  </Flow>
                )}
              </Flow>
            )}
          </VFlow>
        )}
      </VFlow>
      {value.resultado && <ConsultaSeguimentoIndicatorResultado resultado={value.resultado} />}
    </VFlow>
  )
}
